export default {
  refresh: 'PDF aktualisieren',
  refreshHint: 'Erstellt den Bericht mit der aktuellen Vorlage neu und ersetzt den gespeicherten für alle.',
  longRunning: {
    summary: 'Auditbericht wird erstellt',
    detail: 'Das Erstellen des Berichts kann etwas dauern. Lassen Sie dieses Fenster geöffnet. Diese Meldung schließt sich, sobald der Download beginnt.',
  },
};
